import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Elevation, Icon, TextField, Typography } from 'rmwc';
import { SelectControl } from '../../components/controls/SelectControl';
import { LoadingBar } from '../../components/util/LoadingBar';
import {
  MTHeader,
  MTSkinny,
  MTSubheading,
  MTSubcontent,
  MTSubcontentP,
  MTDivider,
  MTSubcontentHR,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentLabel,
  MTScorePanel,
  MTCTAv2,
  MTLearnMore,
  MTLearnMoreItem,
} from './layout';

import { withRegistrationDialog } from '../../components/RegistrationDialog';
import { withEmailDialog } from '../../components/EmailDialog';
import { wlPath } from '../../helpers/whitelabel';

export class InvestmentFeesAnalysis extends Component {
  constructor(props) {
    super(props);

    this.state = { employerName: null };
  }

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  render() {
    const { dashboard, history } = this.props;

    if (!dashboard) {
      return <LoadingBar />;
    }

    return (
      <div>
        <MTHeader title="Get a free fee analysis report" onClick={() => history.push(wlPath('/investment-fees'))} />
        <MTSkinny>
          <MTSubheading title="What is a fee analysis?" />
          <MTSubcontentP>
            Every retirement plan is different&mdash;it offers different investment options, and different added fees.
            Your employer is required to disclose all of this in a document called a "<strong>Fee Disclosure</strong>".
          </MTSubcontentP>
          <MTSubcontentP>
            We will go through that document and lay out where your plan is expensive, what alternatives you have, and
            how much you would save.
          </MTSubcontentP>
          <Button className="mt-4" onClick={() => {}} theme="secondary-bg on-secondary">
            See a sample fee analysis
          </Button>
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="Get started: Tell us about your retirement plan" />
          <MTSubcontentP>
            In order to perform the fee analysis, we need to review the information in your plan's "<strong>
              Fee Disclosure
            </strong>". We can find it based on your employer's name, or you can directly get a copy of it from your
            plan website and upload it here.
          </MTSubcontentP>
          <div className="mb-3" style={{ display: 'flex', alignItems: 'center' }}>
            <Icon className="mr-1" style={{ color: '#f2c94c' }}>
              report
            </Icon>
            <Typography use="body1" theme="text-secondary-on-background">
              <strong>Privacy Note</strong>: we only use this information to research your retirement plan itself. At no
              point do we access any of your personal information.
            </Typography>
          </div>
          <Elevation z={3} className="p-3">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography className="mt-0" use="headline6">
                  Option 1: Tell us about your plan's Fee Disclosure
                </Typography>
                <MTSubcontentP className="pb-0">
                  Use the button to upload your Fee Disclosure file for any plans you'd like to analyze, and we'll send
                  your free report in 24 hours.
                </MTSubcontentP>
              </div>
              <div>
                <img src={require('images/outcome-fees.png')} height={70} />
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button className="mt-4" onClick={() => {}} theme="secondary">
                See an example
              </Button>
              <Button className="mt-4" onClick={() => {}} theme="secondary-bg on-secondary">
                +Upload a file
              </Button>
            </div>
          </Elevation>

          <Elevation z={3} className="mt-3 p-3">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography className="mt-0" use="headline6">
                  Option 2: We'll find it for you
                </Typography>
                <MTSubcontentP className="pb-0">
                  We'll use public data to look up the Fee Disclosure on your behalf. We'll send you a fee analysis
                  report within 48 hours.
                </MTSubcontentP>
              </div>
              <div>
                <img src={require('images/outcome-fees.png')} height={70} />
              </div>
            </div>

            <div className="hrbr-form">
              <div className="flow-textfield" style={{ display: 'flex' }}>
                <TextField
                  className="m-0"
                  style={{ minWidth: '350px' }}
                  type="text"
                  name="employer-name"
                  value={this.state.employerName}
                  label="Employer's Name"
                  onChange={evt => this.onChange(evt, 'employerName')}
                />

                <SelectControl
                  className="ml-3"
                  style={{ minWidth: '100px' }}
                  label="State"
                  value={this.state.employerState}
                  spec={dashboard._spec.fields.state}
                  onChange={evt => this.onChange(evt, 'employerState')}
                />
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                className="mt-4"
                onClick={() => this.props.openRegistrationDialog(() => {}, () => {}, 'HEADER_REGISTER')}
                theme="secondary-bg on-secondary"
              >
                Submit
              </Button>
            </div>
          </Elevation>
          <Button
            className="mt-4"
            onClick={() =>
              this.props.openRegistrationDialog(() => (window.location = '/start'), () => {}, 'SAVE_AND_REVISIT')
            }
            theme="secondary"
          >
            Save this page for later
          </Button>
        </MTSkinny>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.modules.dashboard.data,
  };
}

export default connect(mapStateToProps)(withEmailDialog(withRegistrationDialog(InvestmentFeesAnalysis)));
